import { i18n } from '@/plugins/i18n';
import { PortTypeEnum, PlaceFields } from '@/types/graphql/schemaTypes';
import { resolveSrv, resolve } from 'dns';

export default {
  address: [
    {
      required: true,
      message: i18n.t('validation.address.required').toString(),
      trigger: ['blur', 'change']
    }
  ],
  checkboxGroup: [
    {
      required: true,
      message: i18n.t('validation.checkbox-group.required').toString(),
      trigger: 'change'
    }
  ],
  date: [
    {
      required: true,
      message: i18n.t('validation.date.required').toString(),
      trigger: 'change'
    }
  ],
  description: [
    {
      type: 'string',
      required: true,
      message: i18n.t('validation.description.required').toString(),
      trigger: 'blur'
    }
  ],
  email: [
    {
      type: 'string',
      required: true,
      message: i18n.t('validation.email.required').toString(),
      trigger: 'blur'
    }, {
      type: 'email',
      message: i18n.t('validation.email.valid').toString(),
      trigger: 'blur'
    }
  ],
  fileName: [
    {
      required: true,
      message: i18n.t('validation.file.required').toString(),
      trigger: 'blur'
    }
  ],
  number: [
    {
      type: 'number',
      required: true,
      message: i18n.t('validation.required').toString(),
      trigger: 'blur'
    }
  ],
  newPassword: [
    {
      min: 6,
      message: i18n.t('validation.new-password.min').toString(),
      trigger: 'blur'
    }, {
      type: 'string',
      required: true,
      message: i18n.t('validation.password.required').toString(),
      trigger: 'blur'
    }
  ],
  password: [
    {
      type: 'string',
      required: true,
      message: i18n.t('validation.password.required').toString(),
      trigger: 'blur'
    }
  ],
  port: [
    {
      required: true,
      message: i18n.t('validation.port.required').toString(),
      trigger: ['blur', 'change']
    }
  ],
  radioGroup: [
    {
      required: true,
      message: i18n.t('validation.radio-group.required').toString(),
      trigger: 'change'
    }
  ],
  required: [
    {
      required: true,
      message: i18n.t('validation.required').toString(),
      trigger: ['blur', 'change']
    }
  ],
  unicode: [
    {
      pattern: /^[ -~]*$/,
      message: i18n.t('validation.unicode').toString()
    }
  ],

  /**
   * Rule set generator to generate a rule that
   * will only success when referencePlace.placeType correspond to the desired placeType.
   *
   * Used when validatong that an selected placed ID is valid
   *
   * @param   {PortTypeEnum}  placeType       Desired validation
   * @param   {PlaceFields}   referencePlace  Place Object corresponding to the selected place ID
   *
   * @return  {Object}                        Rule set
   */
  placeType: (placeType: PortTypeEnum, referencePlace: PlaceFields) => {
    return {
      type: 'enum',
      enum: [(referencePlace.placeType === placeType) ? referencePlace.id : 'INVALID'],
      required: true,
      trigger: ['blur', 'change'],
      message: i18n.t(`validation.place-type.${placeType}`)
    };
  }
};
